import { ResponsiveContainer } from 'recharts';

/**
 * Wrapper sobre ResponsiveContainer de recharts.
 *
 * Defaults:
 *  - width="100%" height="100%"
 *  - minWidth={0} minHeight={0}   ← evita el warning "width(-1) height(-1)"
 *    cuando el padre flex/grid no termino layout al montar.
 *
 * Usar siempre dentro de un contenedor con dimensiones explicitas
 * (ej. <div className="h-[240px]"><Chart>...</Chart></div>).
 *
 * Acepta cualquier prop de ResponsiveContainer (se hace spread al final
 * por si necesitas overridear los defaults para un caso particular).
 */
export default function Chart({ children, ...props }) {
  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
      minWidth={0}
      minHeight={0}
      {...props}
    >
      {children}
    </ResponsiveContainer>
  );
}
